import { useI18n } from "i18n/useI18n";

export type CardContent = {
  content: any;
};

const Card: React.FC<CardContent> = (props) => {
  const { t } = useI18n();
  return (
    <center>
      <div
        style={{
          // width: "80%",
          margin: 30,
          maxWidth: 500,
          padding: "20px 10px",
          borderRadius: 10,
          boxShadow: "0px 0px 8px 1px #ccc",
          background: "#f5f5f5",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        // className={styles.card}
      >
        {props.content}
      </div>
    </center>
  );
};

export default Card;
